/**
 * Module errors.
 *
 * @module
 */
/** The index into the vector is out of bounds */
export const EINDEX_OUT_OF_BOUNDS = {
  code: 131072,
  name: "EINDEX_OUT_OF_BOUNDS",
  doc: "The index into the vector is out of bounds",
} as const;
